import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import api, { unwrap } from '../utils/api';
import { useCart } from '../context/CartContext';
import isMobileLayout from '../utils/isMobileLayout';
import './Header.css';
import Icon from './Icon';

const CATEGORY_ICONS = {
  'its-a-boy': '/category-icons/boy.png',
  'its-a-girl': '/category-icons/girl.png',
  'its-an-upsherin': '/category-icons/upsherin.png',
  'its-a-shidduch': '/category-icons/shidduch.png',
  'its-a-bar-mitzvah': '/category-icons/bar-mitzvah.png',
  'its-something-else': '/category-icons/something-else.png',
};

export default function Header() {
  const { cart } = useCart();
  const [categories, setCategories] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileLayout());

  useEffect(() => {
    api.get('/categories/GetAllCategoriesAndSubCategories')
      .then(r => setCategories(unwrap(r)?.categories || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(isMobileLayout());
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleCategoryClick = () => {
    closeMobileMenu();
    const dropdown = document.querySelector('.nav-dropdown');
    if (dropdown) {
      dropdown.classList.add('closing');
      const handleMouseLeave = () => {
        dropdown.classList.remove('closing');
        dropdown.removeEventListener('mouseleave', handleMouseLeave);
      };
      dropdown.addEventListener('mouseleave', handleMouseLeave);
    }
  };

  return (
    <>
      <header className={`header-container ${isScrolled ? 'scrolled' : ''}`}>
        <div className="header-sub-container">
          {isMobile ? (
            <>
              <button
                className="hamburger-btn"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Menu"
              >
                <Icon name="menu" size="28px" />
              </button>
              <a href="/" aria-label="It's a Simcha home">
                <img src="/logo.png" alt="It's a Simcha" className="header-logo-img" />
              </a>
              <Link to="/checkout" className="cart-icon" title="Cart" aria-label="Cart">
                <Icon name="shopping_cart" size="26px" />
              </Link>
            </>
          ) : (
            <>
              <a href="/" aria-label="It's a Simcha home">
                <img src="/logo.png" alt="It's a Simcha" className="header-logo-img" />
              </a>
              <nav className="header-nav">
                <NavLink to="/">Home</NavLink>
                <div className="nav-dropdown" tabIndex={0}>
                  <button type="button">Simchas <Icon name="keyboard_arrow_down" className="caret" /></button>
                  <div className="nav-dropdown-menu">
                    {categories.map(cat => {
                      const icon = CATEGORY_ICONS[cat.friendlyUrlName];
                      const hasChildren = cat.subCategories && cat.subCategories.length > 0;
                      if (!hasChildren) {
                        return (
                          <Link key={cat._id} to={`/categories/${cat.friendlyUrlName}`} onClick={handleCategoryClick}>
                            {icon ? <img src={icon} alt="" className="nav-icon" /> : <Icon name="celebration" className="nav-icon" />} {cat.name}
                          </Link>
                        );
                      }
                      return (
                        <div key={cat._id} className="nav-submenu" tabIndex={0}>
                          <div className="submenu-parent">
                            <Link to={`/categories/${cat.friendlyUrlName}`} style={{ padding: 0, background: 'none', display: 'inline', marginRight: 8 }}>
                              {icon ? <img src={icon} alt="" className="nav-icon" /> : <Icon name="celebration" className="nav-icon" />} {cat.name}
                            </Link>
                            <Icon name="chevron_right" style={{ marginLeft: 8 }} />
                          </div>
                          <div className="nav-submenu-menu">
                            {cat.subCategories.map(sub => (
                              <Link key={sub._id} to={`/categories/${sub.friendlyUrlName}`} onClick={handleCategoryClick}>
                                {sub.name}
                              </Link>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <NavLink to="/contact-us">Contact Us</NavLink>
              </nav>
              <div className="header-icons">
                <Link to="/checkout" title="Cart" className="header-cart"><Icon name="shopping_cart" size="22px" /> {cart?.items?.length || 0}</Link>
              </div>
            </>
          )}
        </div>
      </header>

      {isMobile && mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeMobileMenu} aria-label="Close menu"><Icon name="close" size="28px" /></button>
            <nav className="mobile-nav">
              <Link to="/contact-us" className="mobile-nav-item" onClick={closeMobileMenu}>Contact Us</Link>
              {categories.map(cat => {
                const hasChildren = cat.subCategories && cat.subCategories.length > 0;
                if (!hasChildren) {
                  return (
                    <Link key={cat._id} to={`/categories/${cat.friendlyUrlName}`} className="mobile-nav-item" onClick={closeMobileMenu}>
                      {cat.name}
                    </Link>
                  );
                }
                return (
                  <div key={cat._id} className="mobile-nav-submenu">
                    <Link to={`/categories/${cat.friendlyUrlName}`} className="mobile-nav-item" onClick={closeMobileMenu}>
                      {cat.name}
                    </Link>
                    <div className="mobile-submenu-list">
                      {cat.subCategories.map(sub => (
                        <Link key={sub._id} to={`/categories/${sub.friendlyUrlName}`} className="mobile-submenu-item" onClick={closeMobileMenu}>
                          {sub.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                );
              })}
            </nav>
          </div>
        </div>
      )}
    </>
  );
}
